// react components
import React from 'react'
import {
    isValid,
    parseISO,
} from 'date-fns'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type DateTimeInput816SiteProps = {
    defaultNow?: boolean
    disabled?: boolean
    error: string | undefined
    format: 'date' | 'datetime' | 'time'
    formatDate?: 'dd/MM/yyyy' | 'MM/yyyy' | 'yyyy'
    formatPreviewOnly?: boolean
    label: string
    maxDate?: any
    minDate?: any
    name: string
    onChange: any
    placeholder?: string
    value: any
}

// main
export const DateTimeInput816Site: React.FC<DateTimeInput816SiteProps> = React.memo(({
    defaultNow,
    disabled,
    error,
    format,
    formatDate,
    formatPreviewOnly,
    label,
    maxDate,
    minDate,
    name,
    onChange,
    placeholder,
    value,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    function onInputChange(value: any) {
        try {
            let dateFormat
            if (value) {
                if (format === 'time') {
                    dateFormat = moment(value).format('HH:mm')
                } else if (format === 'datetime' || formatPreviewOnly) {
                    dateFormat = moment(value).format()
                } else {
                    dateFormat = moment(value).format('YYYY-MM-DD')
                }
            } else {
                dateFormat = ''
            }
            onChange({
                name: name,
                value: dateFormat,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'DateTimeInput816Site',
                'onInputChange',
            ))
        }
    }

    if (format === 'date') {
        return (
            <div className={`input-816 date-time-input-816 ${deviceType}`}>
                <span className={`input-816-label ${deviceType}`}>{label}</span>
                <DatePicker
                    calendarClassName='di-calendar'
                    className='dti-816-input'
                    dateFormat={formatDate || 'dd/MM/yyyy'}
                    disabled={disabled}
                    maxDate={maxDate ? parseISO(maxDate) : undefined}
                    minDate={minDate ? parseISO(minDate) : undefined}
                    onChange={date => onInputChange(date)}
                    placeholderText={placeholder}
                    popperClassName='di-popper'
                    selected={isValid(parseISO(value)) ? parseISO(value) : (defaultNow ? parseISO(moment().format()) : null)}
                />
                {error && <span className='input-816-error'>{error}</span>}
            </div>
        )
    }

    if (format === 'datetime') {
        return (
            <div className={`input-816 date-time-input-816 ${deviceType}`}>
                <span className={`input-816-label ${deviceType}`}>{label}</span>
                <DatePicker
                    calendarClassName='di-calendar'
                    className='dti-816-input'
                    dateFormat='dd/MM/yyyy HH:mm'
                    disabled={disabled}
                    maxDate={maxDate ? parseISO(maxDate) : undefined}
                    minDate={minDate ? parseISO(minDate) : undefined}
                    onChange={date => onInputChange(date)}
                    placeholderText={placeholder}
                    popperClassName='di-popper'
                    selected={isValid(parseISO(value)) ? parseISO(value) : (defaultNow ? parseISO(moment().format()) : null)}
                    showTimeSelect
                    timeFormat='HH:mm'
                />
                {error && <span className='input-816-error'>{error}</span>}
            </div>
        )
    }

    if (format === 'time') {
        return (
            <div className={`input-816 date-time-input-816 ${deviceType}`}>
                <span className={`input-816-label ${deviceType}`}>{label}</span>
                <DatePicker
                    calendarClassName='di-calendar'
                    className='dti-816-input'
                    dateFormat='HH:mm'
                    disabled={disabled}
                    onChange={date => onInputChange(date)}
                    // maxTime={maxDate ? parseISO(maxDate) : undefined}
                    // minTime={minDate ? parseISO(minDate) : undefined}
                    placeholderText={placeholder}
                    popperClassName='di-popper'
                    selected={(value && !['Invalid date'].includes(value)) ? new Date(2024, 1, 1, value.split(':')[0], value.split(':')[1]) : (defaultNow ? parseISO(moment().format()) : null)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeFormat='HH:mm'
                />
                {error && <span className='input-816-error'>{error}</span>}
            </div>
        )
    }

    return null
})
